import React from 'react';

interface QuestionIconProps {
  size?: number;
}

const TimeIcon: React.FC<QuestionIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5 12.9995C22.5 19.0995 17.6 23.9995 11.5 23.9995C5.4 23.9995 0.5 19.0995 0.5 12.9995C0.5 6.89951 5.4 1.99951 11.5 1.99951C17.6 1.99951 22.5 6.89951 22.5 12.9995ZM11.5 13.4995V5.49951V13.4995ZM16 12.9995H11.5H16Z"
      stroke="#333333"
    />
  </svg>
);

export default TimeIcon;
